import Chart from "chart.js";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { find, get, isEqual, map } from "lodash";

import { numberToBRL } from "services/utils";

class BreakEvenChart extends Component {
  componentDidMount() {
    this.handleChart();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.handleChart();
    }
  }

  handleChart() {
    const { ano, data } = this.props;
    const ctx = `chart-break-even-${ano}`;
    const labels = ['A4 - Azul', 'A4 - Verde', 'A3', 'A2'];

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          backgroundColor: 'rgb(22, 186, 207)',
          borderColor: 'rgb(22, 186, 207)',
          borderWidth: 1,
          label: 'Break Even',
          stack: 'Stack 1',
          data: map(labels, label => get(find(data, ['subgrupo', label]), 'simuladorEconomia')),
        }, {
          backgroundColor: 'rgba(54, 162, 235, 0.4)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          label: 'Preço de Mercado',
  				stack: 'Stack 2',
  				data: map(labels, label => get(find(data, ['subgrupo', label]), 'curvaForwardBBCE')),
        }],
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: value => `${numberToBRL(value)}/MWh`,
            },
          }],
        },
        title: {
          display: true,
          text: ano,
        },
        tooltips: {
          callbacks: {
            label: tooltipItem => `${numberToBRL(tooltipItem.yLabel)}/MWh`,
          },
          intersect: false,
          mode: 'index',
        },
      },
    });
  }

  render() {
    return (
      <div>
        <canvas id={"chart-break-even-" + this.props.ano} />
      </div>
    );
  }
};

BreakEvenChart.propTypes = {
  ano: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    curvaForwardBBCE: PropTypes.number.isRequired,
    precoMedioDistribuidora: PropTypes.number.isRequired,
    pld: PropTypes.number.isRequired,
    simuladorEconomia: PropTypes.number.isRequired,
    subgrupo: PropTypes.string.isRequired,
  })).isRequired,
};

export default BreakEvenChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/BreakEvenChart.jsx